module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic_1.0b02b123.woff2";